import { Theme } from '../types';

import { darkTheme } from './dark';
import { lightTheme } from './light';

export * from './dark';
export * from './components';
export * from './light';
export * from './base';

export type ThemeType = {
  lightTheme?: Theme;
  darkTheme?: Theme;
};

export const PlatformTheme = {
  lightTheme,
  darkTheme,
};
